import React from 'react';
import { Typography, Box, Alert, Paper } from '@mui/material';

const EmployeePaystubs = () => (
  <Box>
    <Typography variant="h5" sx={{ fontSize: '1.25rem', fontWeight: 600, mb: 1.5 }}>
      Paystubs
    </Typography>
    <Paper sx={{ p: 2 }}>
      <Alert severity="info">
        Paystub viewing is coming soon. Contact HR or payroll if you need a copy of your pay stub.
      </Alert>
    </Paper>
  </Box>
);

export default EmployeePaystubs;
